// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { ProductContext } from 'Contexts/ProductContext';

export default function useProduct() {
  return useContext(ProductContext);
}
